import { createContext, useContext } from 'react';

import type { AccordionGroupContextProps } from './accordion-group.types';

const AccordionGroupContext = createContext<AccordionGroupContextProps | null>(null);

export function useAccordionGroupContext(): AccordionGroupContextProps | null {
  return useContext(AccordionGroupContext);
}

export default AccordionGroupContext;
